export var MessengerMode;
(function (MessengerMode) {
    MessengerMode["NORMAL"] = "normal";
    MessengerMode["FLOATING"] = "floating";
})(MessengerMode || (MessengerMode = {}));
export var MessengerHeight;
(function (MessengerHeight) {
    MessengerHeight[MessengerHeight["TINY"] = 250] = "TINY";
    MessengerHeight[MessengerHeight["SMALL"] = 550] = "SMALL";
    MessengerHeight[MessengerHeight["NORMAL"] = 704] = "NORMAL";
})(MessengerHeight || (MessengerHeight = {}));
